












import { Component, Vue } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';

@Component({})
export default class ContentContainer extends Vue {
  @State
  public previewUrl!: string;

  @Mutation
  public setPreviewImage!: (url: string) => any;


  public closePreview() {
    this.setPreviewImage('');
  }
}
